import { createTheme } from "@mui/material/styles";

// ---------------------------------------------------------------------------
// Design tokens — shared by every auth page (SignIn, RequestResetPassword, ...)
// Motif: ruled notebook / academic ledger. The ink panel carries horizontal
// rule lines; a single brass rule under each form heading echoes them.
// ---------------------------------------------------------------------------
export const ink = {
  900: "#16233F",
  800: "#1F3358",
  700: "#223A63",
};
export const brass = "#C9A227";
export const paper = "#FAFAF8";
export const ash = "#5B6472";
export const hairline = "#E4E1D8";

// Faixa de linhas horizontais (pauta de caderno) usada como textura do
// painel de marca — leve, sem imagem externa.
export const ruledLinesBg = {
  backgroundImage: `repeating-linear-gradient(
    to bottom,
    transparent,
    transparent 34px,
    rgba(255,255,255,0.06) 34px,
    rgba(255,255,255,0.06) 35px
  )`,
};

export const authTheme = createTheme({
  palette: {
    primary: { main: ink[900] },
    secondary: { main: brass },
    background: { default: paper },
    text: { primary: ink[900], secondary: ash },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", sans-serif',
    h1: { fontFamily: '"Fraunces", "Georgia", serif' },
  },
  components: {
    MuiTextField: {
      defaultProps: { variant: "outlined" },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 4,
            backgroundColor: "#fff",
            "& fieldset": { borderColor: hairline },
            "&:hover fieldset": { borderColor: ash },
            "&.Mui-focused fieldset": { borderColor: brass, borderWidth: 1.5 },
          },
          "& .MuiInputLabel-root.Mui-focused": { color: ink[900] },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: "none",
          fontWeight: 600,
          letterSpacing: "0.01em",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 4, alignItems: "center" },
      },
    },
  },
});

// Google Fonts usadas pelo tema (adicionar no <head> do index.html):
// <link rel="preconnect" href="https://fonts.googleapis.com">
// <link href="https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600&family=Inter:wght@400;500;600&display=swap" rel="stylesheet">
